import { FileBarChart2 } from "lucide-react";
import { useLocale } from "@/context/LanguageContext";

interface Props {
  onGenerate: () => void;
}

/**
 * Friendly empty state shown when an org has never generated a report.
 * The CTA mirrors the page header button so the action is discoverable
 * regardless of where the user's eye lands first.
 */
export function ReportsEmptyState({ onGenerate }: Props) {
  const { t } = useLocale();
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card p-12 text-center">
      <FileBarChart2
        className="h-10 w-10 text-muted-foreground"
        aria-hidden="true"
      />
      <h3 className="mt-4 text-base font-semibold text-foreground">
        {t("reports.empty.title")}
      </h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">
        {t("reports.empty.body")}
      </p>
      <button
        type="button"
        onClick={onGenerate}
        className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-sm transition hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
      >
        {t("reports.cta.generate")}
      </button>
    </div>
  );
}
